import { requestTaxInvoiceApi } from "./taxInvoiceReconciliationService";

const base = "/api/tax-invoice-reconciliation/automation/legacy";
export const fetchLegacyConfig = () => requestTaxInvoiceApi(`${base}/config`);
export const saveLegacySettings = (settings) => requestTaxInvoiceApi(`${base}/settings`, { method: "PUT", body: settings });
export const fetchLegacyJobs = () => requestTaxInvoiceApi(`${base}/jobs`);
export const fetchLegacyJob = (id) => requestTaxInvoiceApi(`${base}/jobs/${encodeURIComponent(id)}`);
export const startLegacyReconciliation = (request) => requestTaxInvoiceApi(`${base}/run`, { method: "POST", body: request });
